import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const getContacts = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/contacts${qs}`)
}

export const optInToNewContactsPage = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return mutateApi({
    url: `/manage/${marinaSlug}/contacts/opt_in`,
    method: "POST",
  })
}

export const archiveContact = (contactId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/archive`,
    method: "POST",
  })
}

export const restoreContact = (
  marinaSlug,
  contactId,
  { contactBoatIds = [] } = {}
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/restore`,
    method: "POST",
    data: contactBoatIds.length ? { contactBoatIds } : {},
  }).then((response) => response.data)

export const getContactPaymentMethods = ({ marinaSlug, contactId }) => {
  return queryApi(`/manage/${marinaSlug}/contacts/${contactId}/cards`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const queryContactMessages = async (
  marinaId,
  contactId,
  { page, readStatus, types = [] } = {}
) => {
  const queryParts = []

  if (page) queryParts.push(`page=${page}`)
  if (readStatus && readStatus !== "all")
    queryParts.push(`read_status=${readStatus}`)
  types.forEach((t) => queryParts.push(`types=${t}`))

  const query = queryParts.length ? `?${queryParts.join("&")}` : ""
  return queryApi(
    `/manage/${marinaId}/contacts/${contactId}/messages${query}`,
    {
      headers: { Accept: "application/json" },
    }
  )
}

export const queryContactWorkOrders = (contactId, page) => {
  const marinaSlug = getCurrentMarinaSlug()
  return queryApi(
    `/manage/${marinaSlug}/contacts/${contactId}/work_orders.json?page=${page}`
  )
}

export const searchContactsIncludingArchived = (
  marinaSlug,
  query,
  { includeNetwork = false, extraFields = [] } = {}
) => {
  const params = new URLSearchParams({ q: query, include_archived: "true" })
  if (includeNetwork) params.append("include_network", "true")
  if (extraFields.length) params.append("include", extraFields.join(","))
  return queryApi(
    `/manage/${marinaSlug}/contacts/search.json?${params.toString()}`
  )
}

export const getArchivedContactBoats = (marinaSlug, contactId) =>
  queryApi(
    `/manage/${marinaSlug}/contacts/${contactId}/contact_boats?status=archived`
  ).then((response) => response.data)
